import UserManager from "./manager/UserManager";
import { MAIN_ROLES } from "@/config/roles";

const PaymentPermissionService = {
  // Estados que ya no permiten acciones de reportar impago para suppliers
  // Solo EXPIRED (4) permite reportar impago
  // NON_PAYMENT (5) ya fue reportado
  // NOT_REPORTED (10) ya no se puede reportar
  NO_REPORT_STATES: [5, 10], // non_payment, not_reported

  // Estados pagados donde solo se puede ver información
  PAID_STATES: [3, 6, 7, 8], // paid, paid_by_mangxo, paid_to_mangxo, payment_in_financing

  isSupplier() {
    return UserManager.getMainRole() === MAIN_ROLES.SUPPLIER;
  },

  isCustomer() {
    return UserManager.getMainRole() === MAIN_ROLES.CUSTOMER;
  },

  // Verifica si un pago está en estado que ya no permite reportar impago
  cannotReportPayment(payment) {
    if (!payment) return false;
    const status =
      payment.status_id || payment.status || payment.payment_status || 0;
    return this.NO_REPORT_STATES.includes(parseInt(status));
  },

  // Verifica si un pago está en estado pagado
  isPaidPayment(payment) {
    if (!payment) return false;
    const status =
      payment.status_id || payment.status || payment.payment_status || 0;
    return this.PAID_STATES.includes(parseInt(status));
  },

  // Verifica si se puede reportar impago (solo EXPIRED = 4)
  canReportNonPayment(payment) {
    if (!payment || !this.isSupplier()) return false;
    const status =
      payment.status_id || payment.status || payment.payment_status || 0;
    return parseInt(status) === 4; // Solo expired
  },

  // Verifica si se puede editar (pending o rejected para suppliers)
  canEdit(payment) {
    if (!payment || !this.isSupplier()) return false;
    const status =
      payment.status_id || payment.status || payment.payment_status || 0;
    return [1, 9].includes(parseInt(status)); // pending, rejected
  },

  // Verifica si customer puede subir comprobante (solo rejected)
  canUploadProof(payment) {
    if (!payment || !this.isCustomer()) return false;
    const status =
      payment.status_id || payment.status || payment.payment_status || 0;
    return parseInt(status) === 9; // rejected
  },
  canPerformActions({ payment }) {
    if (!payment) return true;

    // Para pagos ya procesados, solo se puede ver información
    if (this.isPaidPayment(payment)) {
      return false;
    }

    return true;
  },

  getDisabledActionMessage({ payment }) {
    if (this.isPaidPayment(payment)) {
      return "El pago ya está procesado";
    }
    if (this.isSupplier() && this.cannotReportPayment(payment)) {
      const status =
        payment.status_id || payment.status || payment.payment_status || 0;
      if (parseInt(status) === 5) {
        return "El impago ya fue reportado";
      }
      if (parseInt(status) === 10) {
        return "Ya no se puede reportar este pago";
      }
    }
    return null;
  },
};

export default PaymentPermissionService;
